import { ArrowRight } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import React, { useEffect, useState } from "react";
import adminAgencyBlogService, { AgencyBlogResponseDto, PaginatedAgencyBlogResponse } from "@/services/admin/agencyBlog.admin.service";
import { RichTextPreview } from "../Editor/RichTextPreview";
import { Link } from "react-router-dom";
import { Pagination } from "../common/Pagination";


const AgencyBlogs = () => {
  const [posts, setPosts] = React.useState<AgencyBlogResponseDto[]>([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const loadBlogs = async (page: number = 1) => {
    try {
      setIsLoading(true);
      const response: PaginatedAgencyBlogResponse =
        await adminAgencyBlogService.list(page, pagination.limit);
      setPosts(response.data);
      setPagination(response.pagination);
    } catch (error) {
      console.error("Error loading blogs:", error);
    }
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadBlogs(pagination.page);
  }, []);

  const handlePageChange = (newPage: number) => {
    setPagination((prev) => ({ ...prev, page: newPage }));
    loadBlogs(newPage);
  };
  
  return (
    <section className="py-6">
      <div className="container mx-auto flex flex-col items-center gap-16 lg:px-16">
        <div className="text-center">
          <Badge variant="secondary" className="mb-6">
            Latest Updates
          </Badge>
          <h2 className="mb-3 text-3xl font-semibold text-pretty md:mb-4 md:text-4xl lg:mb-6 lg:max-w-3xl lg:text-5xl">
            Agency Blogs
          </h2>
          <p className="mb-8 text-muted-foreground md:text-base lg:max-w-2xl lg:text-lg">
            
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
          {posts.map((post) => (
            <Card
              key={post.id}
              className="relative grid grid-rows-[auto_auto_1fr_auto] pt-0"
            >
              <CardHeader className="pt-8">
                <h3 className="text-lg font-semibold hover:underline md:text-xl">
                  <a href={`blogs/${post.id}`}>
                    {post.title}
                  </a>
                </h3>
              </CardHeader>
              <CardContent className="max-h-48 overflow-hidden">
                <RichTextPreview content={post.description} />
              </CardContent>
              <CardFooter className="absolute w-full bottom-6">
                <div className=" flex w-full items-center justify-between pt-4">
                  <div className="text-sm text-muted-foreground">
                    Published on {new Date(post.createdAt).toLocaleDateString()}
                  </div>
                  <Link
                    to={`${post.id}`}
                    className="flex items-center text-foreground hover:underline"
                  >
                    Read more
                    <ArrowRight className="ml-2 size-4" />
                  </Link>
                </div>
              </CardFooter>
            </Card>
          ))}
        </div>
          {!isLoading &&
          <div className="flex w-full justify-center">
           <Pagination
            currentPage={pagination.page}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        </div>
          }
      </div>
    </section>
  );
};

export {AgencyBlogs};
